// Inline form for upserting a single app_settings row. Value is parsed
// as JSON so any serialisable payload works (string, number, object).
import { useState } from "react";

interface Props {
  onUpsert: (key: string, value: unknown) => Promise<void>;
  onError: (message: string) => void;
}

export function AddSettingForm({ onUpsert, onError }: Props) {
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");

  const submit = async () => {
    let parsed: unknown;
    try {
      parsed = JSON.parse(value);
    } catch {
      onError(`Value for '${key}' must be valid JSON`);
      return;
    }
    try {
      await onUpsert(key, parsed);
      setKey("");
      setValue("");
    } catch (e) {
      onError(e instanceof Error ? e.message : String(e));
    }
  };

  return (
    <div className="bsp-card" style={{ marginBottom: 16 }}>
      <div className="bsp-label">Add or update setting</div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 2fr auto",
          gap: 8,
          marginTop: 8,
        }}
      >
        <input
          className="bsp-input"
          placeholder="key"
          value={key}
          onChange={(e) => setKey(e.target.value)}
        />
        <input
          className="bsp-input"
          placeholder='JSON value, e.g. "string", 42, true, {"foo":1}'
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button
          type="button"
          className="bsp-btn bsp-btn-primary bsp-btn-sm"
          disabled={!key || !value}
          onClick={() => void submit()}
        >
          Save
        </button>
      </div>
    </div>
  );
}
